"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var schemas = {
  "intro-banner": {
    data: [{
      name: "image",
      element: ".intro-banner-image img",
      type: "image"
    }, {
      name: "mobileImage",
      element: ".intro-banner-image",
      type: "mobileImage"
    }, {
      name: "video",
      element: ".intro-banner-video source",
      type: "video"
    }, {
      name: "embeddedVideo",
      element: ".intro-banner-video-external iframe",
      type: "iframe"
    }, {
      name: "content",
      element: ".intro-banner-text",
      type: "html"
    }, {
      name: "link",
      element: ".intro-banner-link",
      type: "html"
    }, {
      name: "anchorLink",
      element: ".sticky-downlink a",
      type: "link"
    }, {
      name: "textList",
      element: ".intro-banner-list-spot-content",
      type: "list"
    }]
  },
  "rich-text": {
    data: [{
      name: "content",
      element: ".component-content",
      type: "html"
    }]
  },
  "text-image-spot": {
    data: [{
      name: "image",
      element: ".text-image-spot-image",
      type: "image"
    }, {
      name: "imageDescription",
      element: ".text-image-spot-image-description",
      type: "text"
    }, {
      name: "content",
      element: ".text-image-spot-text",
      type: "html"
    }, {
      name: "link",
      element: ".text-image-spot-image a",
      type: "link"
    }]
  },
  "screening-test-spot": {
    data: [{
      name: "title",
      element: ".questions-intro .dynamic-header h2",
      type: "text"
    }, {
      name: "description",
      element: ".questions-intro .intro-description",
      type: "text"
    }, {
      name: "submitButton",
      element: ".questions-intro .start-test",
      type: "text"
    }, {
      name: "questionsAndResults",
      element: ".questions",
      type: "screeningTestList"
    }]
  },
  "image-spot": {
    data: [{
      name: "elements",
      element: ".image-spot-elements",
      type: "imageSpotList"
    }]
  },
  "news-list-spot": {
    data: [{
      name: "newsListSpot",
      element: "ul",
      type: "newsListSpot"
    }]
  },
  "news-spot-item": {
    data: [{
      name: "title",
      element: ".field-title",
      type: "text"
    }, {
      name: "date",
      element: ".field-date",
      type: "html"
    }, {
      name: "content",
      element: ".field-content",
      type: "html"
    }, {
      name: "image",
      element: ".field-summaryicon img",
      type: "image"
    }, {
      name: "bannerImage",
      element: ".field-newsspotimage img",
      type: "image"
    }]
  },
  blog: {
    data: [{
      name: "image",
      element: ".blog-image img",
      type: "image"
    }, {
      name: "title",
      element: ".blog-title",
      type: "text"
    }, {
      name: "readingTime",
      element: ".blog-reading-time",
      type: "html"
    }, {
      name: "author",
      element: "#main_1_linkAuthor",
      type: "html"
    }, {
      name: "date",
      element: ".blog-date",
      type: "text"
    }, {
      name: "blogContent",
      element: ".blog-content",
      type: "html"
    }]
  },
  "blog-author": {
    data: [{
      name: "authorAbout",
      element: ".blog-author-about",
      type: "text"
    }, {
      name: "authorImage",
      element: ".blog-author-image img",
      type: "image"
    }, {
      name: "authorName",
      element: ".blog-author-name",
      type: "text"
    }, {
      name: "authorTitle",
      element: ".blog-author-title",
      type: "text"
    }, {
      name: "authorIntro",
      element: ".blog-author-intro",
      type: "text"
    }, {
      name: "authorLink",
      element: "#main_2_linkAuthor",
      type: "html"
    }]
  },
  "related-blogs": {
    data: [{
      name: "relatedTitle",
      element: ".related-title",
      type: "text"
    }, {
      name: "relatedList",
      element: ".related-blogs ul",
      type: "relatedList"
    }]
  },
  "author-details": {
    data: [{
      name: "authorImage",
      element: ".author-image img",
      type: "image"
    }, {
      name: "authorHeadline",
      element: ".author-intro h2",
      type: "text"
    }, {
      name: "authorName",
      element: ".author-intro .author-name",
      type: "text"
    }, {
      name: "authorQuote",
      element: ".author-intro .like-quote",
      type: "text"
    }]
  },
  "author-related-blogs": {
    data: [{
      name: "relatedBlogsTitle",
      element: ".related-blogs-title",
      type: "html"
    }, {
      name: "authorRelatedBlogs",
      element: ".author-related-blogs ul",
      type: "authorRelatedBlogs"
    }]
  },
  "news-navigation": {
    data: [{
      name: "linkList",
      element: ".component-content ul",
      type: "linkList"
    }]
  },
  "two-section-grid": {
    data: [{
      name: "sectionOne",
      element: ".section-one",
      type: "html"
    }, {
      name: "sectionTwo",
      element: ".section-two",
      type: "html"
    }]
  },
  "three-section-grid": {
    data: [{
      name: "sectionOne",
      element: ".section-one",
      type: "html"
    }, {
      name: "sectionTwo",
      element: ".section-two",
      type: "html"
    }, {
      name: "sectionThree",
      element: ".section-three",
      type: "html"
    }]
  },
  container: {
    data: [{
      name: "content",
      element: ".component-content",
      type: "html"
    }]
  },
  header: {
    data: [{
      name: "bigLogo",
      element: ".section-one .header-logo a img",
      type: "image"
    }, {
      name: "smallLogo",
      element: ".section-two .header-logo a img",
      type: "image"
    }, {
      name: "languageSelector",
      element: ".language-selector-spot .component-content",
      type: "languagesList"
    }, {
      name: "search",
      element: ".search-field-spot ",
      type: "search"
    }, {
      name: "headerTop",
      element: ".section-one",
      type: "headerContent"
    }, {
      name: "headerBottom",
      element: ".section-two",
      type: "headerContent"
    }]
  },
  "blog-categories": {
    data: [{
      name: "blogCategories",
      element: ".blog-categories-content-wrapper",
      type: "blogCategories"
    }]
  },
  "blog-list": {
    data: [{
      name: "blogList",
      element: "#blog-list",
      type: "blogList"
    }]
  },
  navigation: {
    data: [{
      name: "navigation",
      element: ".component-content ul",
      type: "linkList"
    }]
  },
  "link-list": {
    data: [{
      name: "linkList",
      element: ".component-content ul",
      type: "linkList"
    }]
  },
  "search-field-spot": {
    data: [{
      name: "searchFieldSpot",
      element: ".component-content .search-field",
      type: "searchFieldSpot"
    }]
  }
};
var _default = schemas;
exports["default"] = _default;